import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useTranslations } from "use-intl";

interface LoadFailedStateProps {
  onCancel: () => void;
  onRetry: () => void;
}

/**
 * Final #462 whole-branch review, finding 3 / design spec AC8 — shared across every "match to
 * transaction" modal (payables, receivables, receipts): a fetch failure is NOT the same as "no
 * suggestions" — must never silently fall through to the acknowledgment checkbox as if a
 * completed, genuinely empty search had run.
 */
export default function LoadFailedState({ onCancel, onRetry }: LoadFailedStateProps) {
  const t = useTranslations("consultantMatching.shared");
  return (
    <div className="space-y-4">
      <Alert variant="destructive">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>{t("loadFailedTitle")}</AlertTitle>
        <AlertDescription>{t("loadFailedBody")}</AlertDescription>
      </Alert>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel}>{t("cancel")}</Button>
        <Button onClick={onRetry}>
          <RefreshCw className="h-3.5 w-3.5 mr-1" />
          {t("tryAgain")}
        </Button>
      </DialogFooter>
    </div>
  );
}
